import {
  CategoryBackOfHouse,
  CategoryCompliance,
  CategoryFrontOfHouse,
  CategoryGeneral,
  CategoryHospitality,
  CategoryLeadership,
  CategoryOnboarding,
} from 'icons';

import Constants from '../constants';

import { TranslationKey } from '@/i18n';

export const mapCategoryToColor = (
  category = Constants.PLAN_CATEGORIES.GENERAL,
  isDisabled?: boolean,
) => {
  if (isDisabled === true) {
    return Constants.PLAN_CATEGORY_COLORS.IS_DISABLED;
  }
  switch (category) {
    case Constants.PLAN_CATEGORIES.GENERAL:
      return Constants.PLAN_CATEGORY_COLORS.GENERAL;
    case Constants.PLAN_CATEGORIES.BACK_OF_HOUSE:
      return Constants.PLAN_CATEGORY_COLORS.BACK_OF_HOUSE;
    case Constants.PLAN_CATEGORIES.COMPLIANCE:
      return Constants.PLAN_CATEGORY_COLORS.COMPLIANCE;
    case Constants.PLAN_CATEGORIES.FRONT_OF_HOUSE:
      return Constants.PLAN_CATEGORY_COLORS.FRONT_OF_HOUSE;
    case Constants.PLAN_CATEGORIES.HOSPITALITY:
      return Constants.PLAN_CATEGORY_COLORS.HOSPITALITY;
    case Constants.PLAN_CATEGORIES.ONBOARDING:
      return Constants.PLAN_CATEGORY_COLORS.ONBOARDING;
    case Constants.PLAN_CATEGORIES.LEADERSHIP:
      return Constants.PLAN_CATEGORY_COLORS.LEADERSHIP;

    default:
      return Constants.PLAN_CATEGORY_COLORS.GENERAL;
  }
};

export const mapCategoryToIcon = (
  category = Constants.PLAN_CATEGORIES.GENERAL,
) => {
  switch (category) {
    case Constants.PLAN_CATEGORIES.GENERAL:
      return <CategoryGeneral />;
    case Constants.PLAN_CATEGORIES.BACK_OF_HOUSE:
      return <CategoryBackOfHouse />;
    case Constants.PLAN_CATEGORIES.COMPLIANCE:
      return <CategoryCompliance />;
    case Constants.PLAN_CATEGORIES.FRONT_OF_HOUSE:
      return <CategoryFrontOfHouse />;
    case Constants.PLAN_CATEGORIES.HOSPITALITY:
      return <CategoryHospitality />;
    case Constants.PLAN_CATEGORIES.ONBOARDING:
      return <CategoryOnboarding />;
    case Constants.PLAN_CATEGORIES.LEADERSHIP:
      return <CategoryLeadership />;
    default:
      return <CategoryGeneral />;
  }
};

export const mapCategoryToAliasTranslation = (
  category = Constants.PLAN_CATEGORIES.GENERAL,
): TranslationKey => {
  switch (category) {
    case Constants.PLAN_CATEGORIES.GENERAL:
      return 'TrainingPlans.planCategories.general';
    case Constants.PLAN_CATEGORIES.BACK_OF_HOUSE:
      return 'TrainingPlans.planCategories.backOfHouse';
    case Constants.PLAN_CATEGORIES.COMPLIANCE:
      return 'TrainingPlans.planCategories.compliance';
    case Constants.PLAN_CATEGORIES.FRONT_OF_HOUSE:
      return 'TrainingPlans.planCategories.frontOfHouse';
    case Constants.PLAN_CATEGORIES.HOSPITALITY:
      return 'TrainingPlans.planCategories.hospitality';
    case Constants.PLAN_CATEGORIES.ONBOARDING:
      return 'TrainingPlans.planCategories.onboarding';
    case Constants.PLAN_CATEGORIES.LEADERSHIP:
      return 'TrainingPlans.planCategories.leadership';
    default:
      return 'TrainingPlans.planCategories.general';
  }
};
